import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendProjectFolder,
  BackendQueryProjectFolderArgs,
  BackendWorkspace,
} from 'src/types/backend';

const QUERY = gql`
  query ProjectFolder($id: ID!) {
    projectFolder(id: $id) {
      id
      workspace {
        id
        customerId
      }
    }
  }
`;

type Variables = BackendQueryProjectFolderArgs;
type Result = Pick<BackendProjectFolder, 'id'> & {
  workspace: Pick<BackendWorkspace, 'id' | 'customerId'>;
};

export const queryProjectFolder = async (
  variables: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  return getSingleProp<Result>(result.data);
};
